<template>
  <!-- MBR031 Membership activated — member_app_UI/song_fa_members_membership_tiers -->
  <div :style="styleObject" class="page-header align-items-start mbr-msdone">
    <span class="mask bg-white"></span>
    <div class="container">
      <div class="mbr-msdone__card">
        <span class="mbr-msdone__emblem" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </span>
        <h1 class="mbr-msdone__title">{{ $t('membership.congratulations') }}</h1>
        <p class="mbr-msdone__text">{{ $t('membership.activated_success') }}</p>
        <button type="button" class="mbr-msdone__cta" @click="closePage">{{ $t('common.close') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import "bootstrap/dist/js/bootstrap.bundle";
import { getMerchantCode } from "@/config/utils";

export default {
  name: "get-membership-success",
  data() {
    return {
      merchantCode: ""
    };
  },
  // draws its own chrome like the design, same as GetMemberShip
  beforeMount() {
    this.toggleNavbarOnly();
    this.toggleHideConfig();
    const app = document.querySelector("#app");
    app.classList.add("mbr-sidenav-overlay");
    app.classList.remove("g-sidenav-pinned");
  },
  beforeUnmount() {
    this.toggleNavbarOnly();
    this.toggleHideConfig();
    const app = document.querySelector("#app");
    app.classList.remove("mbr-sidenav-overlay");
    if (window.innerWidth > 1200) {
      app.classList.add("g-sidenav-pinned");
    }
  },
  mounted() {
      const code = getMerchantCode();
      this.merchantCode = code ? `/${code}` : "";
  },
  computed: {
    styleObject() {
        return {
            '--label-color': this.$store.state.labelColor,
        };
    },
  },
  methods: {
      ...mapMutations(["toggleEveryDisplay", "toggleHideConfig", "toggleNavbarOnly"]),
      ...mapActions(["setHeaderColor", "setLabelColor", "setButtonColor"]),
      closePage() {
          // window.location.href = location.protocol + '//' + location.host+"/minty/profile"
          window.location.href = this.merchantCode+'/home'
      },
  },
};
</script>
<style scoped>
/* MBR031. The old block was unscoped and duplicated `.item-content h4`, `.avatar-invite` and
   `#invite-friends p` — InviteFriends.vue defines all three itself, so dropping them here
   changes nothing outside this view. */
.mbr-msdone.page-header {
  min-height: 100vh;
  font-family: var(--mbr-font-body);
}

/* Landing/Store ship an unscoped `* { font-family: Poppins }`; `*` hits every element directly so
   inheritance never reaches them. :where() keeps this at zero specificity. */
.mbr-msdone :where(:not(.material-icons-round)) {
  font-family: var(--mbr-font-body);
}

.mbr-msdone .mask {
  background: var(--mbr-color-canvas) !important;
  opacity: 1;
}

.mbr-msdone .container {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 440px;
  min-height: 100vh;
  margin: 0 auto;
  padding: 24px 20px;
}

.mbr-msdone__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 40px 24px 28px;
  background: var(--mbr-color-card);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.4);
  border-radius: var(--mbr-radius-xl);
  box-shadow: var(--mbr-shadow-card);
  text-align: center;
}

.mbr-msdone__emblem {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 88px;
  height: 88px;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-peach);
  color: var(--mbr-color-primary);
}

.mbr-msdone__emblem svg {
  width: 40px;
  height: 40px;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-msdone__title {
  margin: 24px 0 0;
  font-family: var(--mbr-font-headline);
  font-size: var(--mbr-headline-md-size);
  font-weight: var(--mbr-headline-md-weight);
  line-height: var(--mbr-headline-md-line);
  letter-spacing: var(--mbr-headline-md-tracking);
  color: var(--mbr-color-ink-headline);
}

.mbr-msdone__text {
  margin: 8px 0 0;
  font-size: var(--mbr-body-md-size);
  line-height: var(--mbr-body-md-line);
  color: var(--mbr-color-ink-secondary);
}

.mbr-msdone__cta {
  width: 100%;
  margin-top: 28px;
  padding: 16px;
  border: 0;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-primary);
  box-shadow: var(--mbr-shadow-card);
  font-family: var(--mbr-font-headline);
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
  color: var(--mbr-color-on-primary);
  transition: transform 0.15s ease;
}

.mbr-msdone__cta:active {
  transform: scale(0.98);
}
</style>
